












































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { directives } from 'vuetify/lib';

interface Inputs {
  bodyWeight: string;
  scale: string;
  weightMeasurement: string;
  deadWeight: number;
  benchWeight: number;
  cleanWeight: number;
}

@Component
export default class Control extends Vue {
  private disableContinueButton: boolean = true;
  private deadliftWeight: number = 0;
  private benchWeight: number = 0;
  private cleanWeight: number = 0;
  private weight: string = '';
  private selectedScale: string = '1';
  private scaleItems: any = [
    { text: 'Rx', value: '1' },
    { text: 'Intermediate', value: '2' },
    { text: 'Beginner', value: '3' },
  ];
  private weightMeasurement: string = '0';

  constructor() {
    super();
  }

  private get buttonTextSize() {
    let rval: string;

    switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          rval = 'subheading';
          break;
        case 'md':
        case 'lg':
        case 'xl':
        default:
          rval = 'display-1';
          break;
      }

    return(rval);
  }

  private created() {
    const savedInputs: any = localStorage.getItem('lindaParameters');

    if ( savedInputs ) {
      const inputs: Inputs = JSON.parse(savedInputs);
      this.weight = inputs.bodyWeight;
      this.selectedScale = inputs.scale;
      this.weightMeasurement = inputs.weightMeasurement;
      this.deadliftWeight = inputs.deadWeight;
      this.benchWeight = inputs.benchWeight;
      this.cleanWeight = inputs.cleanWeight;
      this.disableContinueButton = false;
    }
  }

  private changeScale(newItem: string) {
    this.$emit('scale-changed', newItem);
    this.selectedScale = newItem;
    this.recalculate();
  }

  private recalculate() {
    let deadliftMultiplier = 1;
    let benchMultiplier = 1;
    let cleanMultiplier = 1;

    if (this.weight) {
      this.disableContinueButton = false;

      if ( this.selectedScale === '1') {
        deadliftMultiplier = 1.5;
        benchMultiplier = 1;
        cleanMultiplier = .75;
      } else if ( this.selectedScale === '2') {
        deadliftMultiplier = 1.25;
        benchMultiplier = .75;
        cleanMultiplier = .50;
      } else if ( this.selectedScale === '3') {
        deadliftMultiplier = .75;
        benchMultiplier = .50;
        cleanMultiplier = .33;
      }

      this.deadliftWeight = Math.round(parseInt(this.weight, 10) * deadliftMultiplier);
      this.benchWeight = Math.round(parseInt(this.weight, 10) * benchMultiplier);
      this.cleanWeight = Math.round(parseInt(this.weight, 10) * cleanMultiplier);

      this.$emit('update-body-weight', this.weight);
    } else {
      this.disableContinueButton = true;
      this.deadliftWeight = 0;
      this.benchWeight = 0;
      this.cleanWeight = 0;
    }
  }

  private setupComplete() {
    /*
      setup complete
    */

    // save inputs to local storage
    const parmsKey: string = 'lindaParameters';
    const inputs: Inputs = {
      bodyWeight: this.weight,
      scale: this.selectedScale,
      weightMeasurement: this.weightMeasurement,
      deadWeight: this.deadliftWeight,
      benchWeight: this.benchWeight,
      cleanWeight: this.cleanWeight,
    };
    localStorage.setItem('lindaParameters', JSON.stringify(inputs));

    const scale = this.scaleItems[parseInt(this.selectedScale, 10) - 1].text;
    this.$emit('setup-complete', this.deadliftWeight, this.benchWeight, this.cleanWeight, scale); // finished setup
  }

  private changeWeightMeasurement(val: number) {
    this.$emit('change-weight-measurement', val);
  }
}
